import {COLOR, Image, Text, View} from '@lookiero/aurora';
import React, {ReactNode, useEffect, useState} from 'react';
import {useIntl} from 'react-intl';
import {IMAGES_URL} from '@cdn';
import {style} from './PersonalShopperDialog.style';

import {TEXT} from './PersonalShopperDialog.definition';
import {LocationApplication} from '@application/Site';
import {PersonalShopperMessage} from './PersonalShopperMessage';

interface PersonalShopperDialogProps {
  readonly testID?: string;
  readonly message: string;
  readonly children: ReactNode;
}

const PersonalShopperDialog: React.FC<PersonalShopperDialogProps> = ({testID, message, children}) => {
  const {formatMessage} = useIntl();

  const [site, setSite] = useState<string>('');

  // TODO: Is there no other way to take the site?
  // We can not use 'country' because, for co.uk, countrys is different to site
  useEffect(() => {
    setSite(LocationApplication.getStore());
  }, []);

  if (!site) return null;

  const imageUrl = `${IMAGES_URL()}/ps/${site}/v1/ps.png`;

  return (
    <View style={style.wrapper} testID={testID}>
      <View style={style.personalShopperInfo}>
        <View style={style.imageContainer}>
          <Image style={style.image} src={imageUrl} resizeMode="cover" />
        </View>

        <View style={style.info}>
          <Text action level={3}>
            {formatMessage(TEXT.PS_NAME)}
          </Text>

          <Text detail level={2} color={COLOR.TEXT_MEDIUM}>
            {formatMessage(TEXT.PS_ROLE)}
          </Text>
        </View>
      </View>
      <PersonalShopperMessage message={message} />
      <View style={style.content}>{children}</View>
    </View>
  );
};

export {PersonalShopperDialog};
